// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"29":"b3eacf08","591":"b3eacf08","665":"b3eacf08","773":"428027cc"}[chunkId] + ".chunk.css";
};